var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('assembleia-configuracao-edit',{on:{"gravado":_vm.onGravar}}),_c('hr'),(_vm.assembleia.id)?_c('assembleia-item-pauta-list',{attrs:{"assembleia":_vm.assembleia}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }